import * as React from 'react'
function SvgTriangleRight(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M31 19.998c0-.57-.278-1.106-.747-1.433l-17.5-12.25A1.75 1.75 0 0010 7.748V32.25a1.748 1.748 0 002.753 1.433l17.5-12.25c.469-.325.747-.86.747-1.431v-.004c0 .002 0 .002 0 0z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgTriangleRight
